import React from 'react'
import ConfirmPasswordTemplate from '../../../Templates/Auth/ForgotPassword/ConfirmPassword.template'

function ConfirmPasswordPage() {
  return (
    <ConfirmPasswordTemplate />
  )
}

export default ConfirmPasswordPage